var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoublearrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.319 3.737a.463.463 0 0 0 0 .526l2.313 2.666c.099.114.242.088.32-.057A.443.443 0 0 0 5 6.666V1.334C5 1.15 4.898 1 4.772 1c-.05 0-.1.025-.14.071L2.319 3.737zM5.319 3.737a.463.463 0 0 0 0 .526l2.313 2.666c.099.114.242.088.32-.057A.443.443 0 0 0 8 6.666V1.334C8 1.15 7.898 1 7.772 1c-.05 0-.1.025-.14.071L5.319 3.737z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoublearrow);
export default __webpack_public_path__ + "static/media/doublearrow.a31b1596878b71b6732127a79131fd8d.svg";
export { ForwardRef as ReactComponent };